import { useEffect, useRef, useState } from "react";
import { Button } from "reactstrap";
import { ButtonGroup } from "reactstrap";
import MonthYearPicker from "../../MonthYearPicker";
import useMonthYear from "../../MonthYearPicker/useMonthYear";
import AssignedTrainingRecords from "./AssignedTrainingRecords";
import { extractReactTableData, fileDownload, SchemaType } from "../../../utils";
import RecurringTrainingRecords from "./RecurringTrainingRecords";

type Types = 'ASSIGNED' | 'RECURRING';
const TYPES_ARRAY: Array<Types> = ['ASSIGNED', 'RECURRING']

export default function ViewTraining () {

    const [type, setType] = useState<Types>('ASSIGNED');

    return (
        <div>
            <ButtonGroup className={'mb-4'}>
                {
                    TYPES_ARRAY.map(t => (
                        <Button 
                            key={t}
                            onClick={() => setType(t)}
                            active={type === t}
                        >
                            {t}
                        </Button>
                    ))
                }
            </ButtonGroup>
            <RenderContent type={type} />
        </div>
    );
}

const RenderContent = ({
    type
}: {
    type: Types
}) => {

    const tableRef = useRef();

    const handleExportData = (name: string) => {
        let schema: Array<SchemaType> = [];
        if (type === 'ASSIGNED') {
            schema = [{
                key: 's_module_name',
                name: 'Module'
            }, {
                key: 's_unit',
                name: 'Unit'
            }, {
                key: 's_content_type',
                name: 'Content Type'
            }, {
                key: 's_user_id',
                name: 'User'
            }, {
                key: 'b_completed',
                name: 'Completed'
            }, {
                key: 'f_percent',
                name: 'Percent',
                percent: true
            }, {
                key: 's_assignor',
                name: 'Assigned by'
            }, {
                key: 't_created',
                name: 'Assigned date'
            }];
        } else {
            schema = [{
                key: 's_module_name',
                name: 'Module'
            }, {
                key: 's_unit',
                name: 'Unit'
            }, {
                key: 's_access_type',
                name: 'Type: POWERPOINT/QUIZ'
            }, {
                key: 's_user_id',
                name: 'User'
            }, {
                key: 'd_next_training_date',
                name: 'Next Training Date',
                datetime: true
            }, {
                key: 't_modified',
                name: 'Assigned Date'
            }, {
                key: 'i_training_frequency_months',
                name: 'Training Frequency (months)'
            }];
        }
        const data = extractReactTableData(tableRef, [], schema);
        fileDownload(data, name);
    }

    if (type === 'ASSIGNED') {
        return (
            <AssignedTrainingRecords 
                tableRef={tableRef}
                handleExportData={handleExportData}
            />
        );
    }

    return (
        <RecurringTrainingRecords 
            tableRef={tableRef}
            handleExportData={handleExportData}
        />
    );

}